import { render, staticRenderFns } from "./Inpatient.vue?vue&type=template&id=2595065a"
import script from "./Inpatient.vue?vue&type=script&lang=js"
export * from "./Inpatient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports